/* eslint-disable react/prop-types */
import { DotsItem } from '@nivo/core';
import React from 'react';

const ActivePoint = (props) => {
  return (
    <g>
      {props.currentSlice?.points.map((point) => (
        <DotsItem
          key={point.id}
          x={point.x}
          y={point.y}
          datum={point.data}
          symbol={props.pointSymbol}
          size={props.pointSize}
          color={point.color}
          borderWidth={props.pointBorderWidth}
          borderColor={point.borderColor}
          label={point.label}
          labelYOffset={props.pointLabelYOffset}
        />
      ))}
    </g>
  );
};

export default ActivePoint;
